import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SofiaInviteComponent } from './shared/components/sofia-invite/sofia-invite.component';
@Component({
  imports: [RouterModule, SofiaInviteComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected title = 'Mente Bonita';
}
